import {PaymentMethod} from "@/Enums";

class PaymentDetailsDto {

    id: number = 0;

    paymentMethod: PaymentMethod = PaymentMethod.invoice;

    sepaDebitDate: string | undefined;

    mandateReference: string | undefined | null;
}

export {
    PaymentDetailsDto
}
